<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">適用期間指定</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">

        <div class="column-list">
          <label class="list-input-title">使用開始</label>
          <div class="list-input-content">
            <app-checkbox-label id="chk_NotDesignateStart" #chk_NotDesignateStart [subid]="'chk_NotDesignateStart'"
              label="指定なし" [disabled]="kymw1502Model.notDesignateStartDisabled"
              [(ngModel)]="kymw1502Model.notDesignateStart" (change)="eventNotDesignateStart_CLICKHandler()"
              autofocus="true" [tabindex]="0">
            </app-checkbox-label>
          </div>

          <label class="list-input-title">受注コード</label>
          <div class="list-input-content">
            <app-order-code-text-input id="txt_StartOrderCode" #txt_StartOrderCode [subid]="'txt_StartOrderCode'"
              [catalogIDField]="lbl_StartDelivCatalogId" [disabled]="!kymw1502Model.startOrderCodeEnabled"
              [(ngModel)]="kymw1502Model.startOrderCode" [tabindex]="0">
            </app-order-code-text-input>
          </div>

          <label class="list-input-title">配達企画回(翌週)</label>
          <div class="list-input-content">
            <input type="text" class="deliv-catalog" id="lbl_StartDelivCatalogId" #lbl_StartDelivCatalogId readonly/>
          </div>

          <label class="list-input-title">使用終了</label>
          <div class="list-input-content">
            <app-checkbox-label id="chk_NotDesignateStart" #chk_NotDesignateStart [subid]="'chk_NotDesignateStart'"
              label="指定なし" [disabled]="kymw1502Model.notDesignateEndDisabled"
              [(ngModel)]="kymw1502Model.notDesignateEnd" (change)="eventNotDesignateEnd_CLICKHandler()" [tabindex]="0">
            </app-checkbox-label>
          </div>

          <label class="list-input-title">受注コード</label>
          <div class="list-input-content">
            <app-order-code-text-input id="txt_EndOrderCode" #txt_EndOrderCode [subid]="'txt_EndOrderCode'"
              [catalogIDField]="lbl_EndDelivCatalogId" [disabled]="!kymw1502Model.endOrderCodeEnabled"
              [(ngModel)]="kymw1502Model.endOrderCode" [tabindex]="0">
            </app-order-code-text-input>
          </div>

          <label class="list-input-title">配達企画回(翌週)</label>
          <div class="list-input-content">
            <input type="text" class="deliv-catalog" id="lbl_EndDelivCatalogId" #lbl_EndDelivCatalogId readonly/>
          </div>

        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button class="btn-primary" id="btn_SetMarkFilePeriod"
            (click)="eventSetMarkFilePeriod_CLICKHandler()" [tabindex]="0">設定</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickWindowClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>